import { render, staticRenderFns } from "./PayslipReport.vue?vue&type=template&id=5a63ac1e&scoped=true&"
import script from "./PayslipReport.vue?vue&type=script&lang=js&"
export * from "./PayslipReport.vue?vue&type=script&lang=js&"
import style0 from "./PayslipReport.vue?vue&type=style&index=0&id=5a63ac1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63ac1e",
  null
  
)

export default component.exports